import type { Money } from "@/lib/domain/Money";
import { useHTTP, useHTTPQueryWithCursor, type PaginatedResponseModel } from "@/lib/http";

export interface PriceOverrideDetailsResponseModel {
	readonly priceOverrideId: string;
	readonly variantId: string;
	readonly productId: string;
	readonly price: Money;
	readonly productName: string;
	readonly imageUrl: string;
	readonly fcId: string;
}

export const usePriceOverrideDetails = () => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["priceOverrideDetails"],
		queryFn: ({ pageParam = 0 }) => {
			const result = http<PaginatedResponseModel<PriceOverrideDetailsResponseModel>>({
				method: "GET",
				url: `/price-override?cursor=${pageParam}`
			});

			return result;
		}
	});
};
